import { useCallback } from "react";
import { sessionStorageService } from "../services/session.storage";

/**
 * Thin wrapper over session storage so callers can establish/clear a
 * session without knowing tokens are persisted in localStorage.
 */
export function useSession() {
    const establishSession = useCallback((token) => {
        sessionStorageService.set(token);
    }, []);

    const clearSession = useCallback(() => {
        sessionStorageService.remove();
    }, []);

    const getToken = useCallback(() => sessionStorageService.get(), []);

    return { establishSession, clearSession, getToken };
}
